import React from 'react'

import Panduan from 'app/PemetaanKompetensiPage/pages/Panduan'
import PageHeader from 'app/PemetaanKompetensiPage/components/PageHeader'
import { checkDateTimeServer } from 'app/PemetaanKompetensiPage/utils'

export async function getServerSideProps() {
  const currentDateTimeServer = await checkDateTimeServer()
  return {
    props: { currentDateTimeServer }, // will be passed to the page component as props
  }
}

const PanduanPage = ({ currentDateTimeServer }) => {
  return <Panduan currentDateTimeServer={currentDateTimeServer} />
}

const PanduanPageHeader = () => <PageHeader title="Panduan Ujian" />

PanduanPage.layoutOpts = {
  hasHeader: true,
  className: 'text-default bg-gray-10 !max-w-full !h-full min-h-screen',
  header: PanduanPageHeader,
}
export default PanduanPage
